import { createClient, type CapabilityClient } from '@going-once/client';
import { runtimeConfig } from './config';
import { currentToken } from './auth';

/**
 * The one client for the whole app, built after `/config.json` has loaded.
 *
 * A getter rather than a module-level constant: the base URL comes from a file fetched
 * at boot, so constructing it at import time would capture a value that does not exist
 * yet. `getToken` is called per request, so a refreshed token is picked up without
 * rebuilding anything and a guest simply resolves to undefined.
 */
let client: CapabilityClient | undefined;

export function api(): CapabilityClient {
  if (!client) {
    const config = runtimeConfig();
    client = createClient({ baseUrl: config.apiUrl, mediaBaseUrl: config.mediaUrl, getToken: currentToken });
  }
  return client;
}
